unable to read source [project]/node_modules/encoding-sniffer/src/index.ts